'use client';

import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

const SocialMediaSection = () => {
  const { language } = useLanguage();
  const isRTL = language === 'ar';

  const content = {
    ar: {
      title: 'حساباتنا على مواقع التواصل',
      subtitle: 'تابعنا للحصول على آخر التحديثات والاستشارات القانونية',
    },
    en: {
      title: 'Follow Us on Social Media',
      subtitle: 'Follow us for the latest updates and legal consultations',
    },
  };

  const t = content[language];

  const socialLinks = [
    {
      name: 'LinkedIn',
      icon: 'BriefcaseIcon',
      color: 'bg-blue-600',
      hoverColor: 'hover:bg-blue-700',
      link: 'https://www.linkedin.com/in/شركة-لاو-باكت-للمحاماة-والاستشارات-القانونية-67a4053a0',
    },
    {
      name: 'TikTok',
      icon: 'MusicalNoteIcon',
      color: 'bg-black',
      hoverColor: 'hover:bg-gray-900',
      link: 'https://www.tiktok.com/@lawpact?_r=1&_t=ZS-921LInXeR3w',
    },
    {
      name: 'Snapchat',
      icon: 'SparklesIcon',
      color: 'bg-yellow-400',
      hoverColor: 'hover:bg-yellow-500',
      link: 'https://snapchat.com/t/dc7A5VnQ',
    },
    {
      name: 'YouTube',
      icon: 'PlayCircleIcon',
      color: 'bg-red-600',
      hoverColor: 'hover:bg-red-700',
      link: 'https://www.youtube.com/@lawpact',
    },
  ];

  return (
    <section data-component-id="src/app/landing-page/components/SocialMediaSection.tsx:55:4" data-component-path="src/app/landing-page/components/SocialMediaSection.tsx" data-component-line="55" data-component-end-line="94" data-component-file="SocialMediaSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22social-media%22%2C%22className%22%3A%22py-20%20bg-surface%22%7D"
      id="social-media"
      className="py-20 bg-surface"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div data-component-id="src/app/landing-page/components/SocialMediaSection.tsx:60:6" data-component-path="src/app/landing-page/components/SocialMediaSection.tsx" data-component-line="60" data-component-end-line="93" data-component-file="SocialMediaSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%20lg%3Apx-10%22%7D" className="container mx-auto px-4 lg:px-10">
        {/* Section Header */}
        <div data-component-id="src/app/landing-page/components/SocialMediaSection.tsx:62:8" data-component-path="src/app/landing-page/components/SocialMediaSection.tsx" data-component-line="62" data-component-end-line="69" data-component-file="SocialMediaSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mb-16%22%7D" className="text-center mb-16">
          <h2 data-component-id="src/app/landing-page/components/SocialMediaSection.tsx:63:10" data-component-path="src/app/landing-page/components/SocialMediaSection.tsx" data-component-line="63" data-component-end-line="65" data-component-file="SocialMediaSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22font-playfair%20font-bold%20text-3xl%20md%3Atext-4xl%20lg%3Atext-5xl%20text-primary%20mb-4%22%7D" className="font-playfair font-bold text-3xl md:text-4xl lg:text-5xl text-primary mb-4">
            {t.title}
          </h2>
          <p data-component-id="src/app/landing-page/components/SocialMediaSection.tsx:66:10" data-component-path="src/app/landing-page/components/SocialMediaSection.tsx" data-component-line="66" data-component-end-line="68" data-component-file="SocialMediaSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-inter%20text-lg%20md%3Atext-xl%20text-text-secondary%20max-w-3xl%20mx-auto%22%7D" className="font-inter text-lg md:text-xl text-text-secondary max-w-3xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        {/* Social Media Icons Grid */}
        <div data-component-id="src/app/landing-page/components/SocialMediaSection.tsx:72:8" data-component-path="src/app/landing-page/components/SocialMediaSection.tsx" data-component-line="72" data-component-end-line="92" data-component-file="SocialMediaSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20items-center%20justify-center%20gap-6%20max-w-3xl%20mx-auto%22%7D" className="flex flex-wrap items-center justify-center gap-6 max-w-3xl mx-auto">
          {socialLinks.map((social, index) => (
            <a data-component-id="src/app/landing-page/components/SocialMediaSection.tsx:74:12" data-component-path="src/app/landing-page/components/SocialMediaSection.tsx" data-component-line="74" data-component-end-line="90" data-component-file="SocialMediaSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%7D"
              key={index}
              href={social.link}
              target="_blank"
              rel="noopener noreferrer"
              className={`group flex flex-col items-center justify-center w-32 h-32 ${social.color} ${social.hoverColor} text-white rounded-2xl shadow-card hover:shadow-xl transition-all duration-300 hover:scale-110`}
            >
              <Icon data-component-id="src/app/landing-page/components/SocialMediaSection.tsx:81:14" data-component-path="src/app/landing-page/components/SocialMediaSection.tsx" data-component-line="81" data-component-end-line="86" data-component-file="SocialMediaSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22mb-2%20group-hover%3Aanimate-bounce%22%7D"
                name={social.icon as any}
                size={48}
                variant="solid"
                className="mb-2 group-hover:animate-bounce"
              />
              <span data-component-id="src/app/landing-page/components/SocialMediaSection.tsx:87:14" data-component-path="src/app/landing-page/components/SocialMediaSection.tsx" data-component-line="87" data-component-end-line="89" data-component-file="SocialMediaSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-inter%20font-semibold%20text-sm%22%7D" className="font-inter font-semibold text-sm">
                {social.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialMediaSection;